<template>
  <div class="repair-bill-print">
    <div class="rb-header">
      <img
        src="/media/logos/vdd_hori_logo.png"
        alt="logo"
        class="rb-logo"
      >
      <div class="rb-tagline">
        Hệ thống Mua bán - Thu cũ đổi mới - Sửa chữa
      </div>
      <div class="rb-tagline">
        ĐTDĐ - Tablet - Macbook - Laptop - Phụ kiện
      </div>
      <div class="rb-store-line">
        {{ storeAddress }} <span v-if="storePhone">- {{ storePhone }}</span>
      </div>
    </div>

    <h2 class="rb-title">HÓA ĐƠN DỊCH VỤ</h2>
    <hr class="rb-divider">

    <div class="rb-info-block">
      <div><strong>Tên Khách:</strong> {{ customerName }}</div>
      <div><strong>Số điện thoại:</strong> {{ customerPhone }}</div>
      <div><strong>Sản phẩm:</strong> {{ deviceModel }}</div>
      <div v-if="slip.imei">
        <strong>Imei:</strong> {{ slip.imei }}
      </div>
    </div>

    <hr class="rb-divider">

    <table class="rb-items">
      <thead>
        <tr>
          <th class="rb-col-name">Dịch vụ</th>
          <th class="rb-col-qty text-right">SL</th>
          <th class="rb-col-price text-right">Đơn giá</th>
          <th class="rb-col-discount text-right">Chiết khấu</th>
          <th class="rb-col-amount text-right">Thành tiền</th>
          <th class="rb-col-warranty text-right">BH (tháng)</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(line, idx) in lineItems"
          :key="idx"
        >
          <td>
            {{ line.name }}
            <span v-if="line.noCharge" class="rb-free-tag">(BH DDV)</span>
          </td>
          <td class="text-right">{{ line.quantity }}</td>
          <td class="text-right">{{ formatMoney(line.unitPrice) }}</td>
          <td class="text-right">
            <template v-if="line.noCharge">100%</template>
            <template v-else-if="line.lineDiscount > 0">
              - {{ formatMoney(line.lineDiscount) }}
            </template>
          </td>
          <td class="text-right">{{ formatMoney(line.amount) }}</td>
          <td class="text-right">{{ line.warrantyMonths || '0' }}</td>
        </tr>
        <tr v-if="lineItems.length === 0">
          <td colspan="5" class="text-right">{{ formatMoney(totalAmount) }}</td>
          <td></td>
        </tr>
      </tbody>
      <tfoot v-if="lineItems.length > 0">
        <tr class="rb-subtotal-row" v-if="billDiscountAmount > 0">
          <th colspan="4" class="text-right">Tạm tính</th>
          <th class="text-right">{{ formatMoney(subtotal) }}</th>
          <th></th>
        </tr>
        <tr class="rb-discount-row" v-if="billDiscountAmount > 0">
          <th colspan="4" class="text-right">Chiết khấu hoá đơn</th>
          <th class="text-right">- {{ formatMoney(billDiscountAmount) }}</th>
          <th></th>
        </tr>
        <tr class="rb-total-row">
          <th colspan="4" class="text-right">Khách phải trả</th>
          <th class="text-right">{{ formatMoney(totalAmount) }}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>

    <!-- Khuyến mãi đã áp dụng (Coupon + Voucher) — chỉ info, không ảnh hưởng tổng. -->
    <div class="rb-promo-info" v-if="couponCode || voucherCodes.length">
      <div v-if="couponCode">
        <strong>Mã coupon:</strong> {{ couponCode }}
      </div>
      <div v-if="voucherCodes.length">
        <strong>Voucher áp dụng:</strong> {{ voucherCodes.join(', ') }}
      </div>
    </div>

    <hr class="rb-divider">

    <div class="rb-meta">
      <div><strong>Số HĐ:</strong> {{ billNumber }}</div>
      <div><strong>Số Phiếu:</strong> {{ slip.slipNumber || '-' }}</div>
      <div><strong>Ngày:</strong> {{ billDate }}</div>
      <div><strong>Ghi chú :</strong></div>
    </div>

    <div class="rb-policy">
      <div>- VDD chỉ bảo hành những linh kiện đã sửa chữa/thay thế tại VDD và đủ điều kiện:</div>
      <div>+ Máy không cong main, cong sườn, dập nát, cháy nổ, rơi vỡ, vào nước, ẩm mốc, vào hóa chất, chảy mực hoặc bị tác động ngoại lực.</div>
      <div>+ Tem bảo hành còn nguyên vẹn, không bị bong/ rách/ dán đè/ bị sửa đổi.</div>
      <div>+ Không bị tác động/can thiệp/sửa chữa bởi bên thứ 03.</div>
      <div>- Chính sách bảo hành: xem cụ thể tại web: viendiong.com - Hotline: 1800.6729</div>
      <div class="rb-strong">Ghi chú hóa đơn:</div>
      <div>- Hóa đơn chưa bao gồm phí GTGT.</div>
      <div>- Quý khách vui lòng liên hệ cửa hàng để cung cấp thông tin xuất hóa đơn GTGT trong vòng 24h tính từ ngày mua hàng.</div>
    </div>

    <div class="rb-thanks">Xin cảm ơn quý khách!</div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  buildNoChargeKeys,
  isItemNoCharge,
  computeServiceBillLine,
  getServiceBillDiscount,
} from '@/utils/warranty-service.helpers';

export default {
  name: 'PrintRepairBill',
  props: {
    slip: {
      type: Object,
      default: () => ({}),
    },
    bill: {
      type: Object,
      default: null,
    },
  },
  computed: {
    storeAddress() {
      return (this.bill && this.bill.storeAddress) || '';
    },
    storePhone() {
      return (this.bill && this.bill.storeHotline) || '';
    },
    customerName() {
      return (this.bill && this.bill.customerName) || this.slip.customerName || '-';
    },
    customerPhone() {
      return (this.bill && this.bill.customerPhone) || this.slip.customerPhone || '-';
    },
    deviceModel() {
      const name = this.slip.productName || '';
      const brand = this.slip.brandName ? `${this.slip.brandName} ` : '';
      return `${brand}${name}`.trim() || '-';
    },
    billNumber() {
      return (this.bill && this.bill.billNumber) || '-';
    },
    billDate() {
      // BE đã format sẵn 'HH:mm DD/MM/YYYY' tại billSearchService.getBillInfo
      // (xem createdAtString) — hiển thị thẳng, không re-parse qua moment.
      if (this.bill && this.bill.createdAt) return this.bill.createdAt;
      const fallback = this.slip.returnedAt || this.slip.completedAt || this.slip.createdAt;
      return fallback ? this.formatDate(fallback) : '';
    },
    // Khoá nối các dòng "không tính phí KH" (noChargeCustomer) lấy từ RepairSlipParts —
    // dùng để zero đúng dòng tương ứng bên billItems. Match theo productId, fallback productCode.
    // Lưu ý: nếu 1 SP xuất hiện >1 dòng với cờ khác nhau thì match theo key sẽ gom chung
    // (hiếm gặp với linh kiện BH); khi đó nên tách mã SP để phân biệt.
    noChargeKeys() {
      const parts = (this.slip && this.slip.parts) || [];
      return buildNoChargeKeys(parts.filter((p) => p.noChargeCustomer));
    },
    lineItems() {
      // Render từ BillItems của Hoá đơn bán lẻ (giữ ĐÚNG chiết khấu/voucher đã áp ở HĐ).
      // Logic tính tiền dùng chung qua computeServiceBillLine (DRY với popup tick).
      // Dòng BH DDV (noCharge) → CK 100%, Thành tiền 0đ.
      const items = (this.bill && this.bill.billItems) || [];
      const keys = this.noChargeKeys;
      return items
        .map((it) => {
          const noCharge = isItemNoCharge(it, keys);
          const line = computeServiceBillLine(it, noCharge);
          return {
            name: it.productName || it.name || '',
            quantity: line.quantity,
            unitPrice: line.unitPrice,
            lineDiscount: line.lineDiscount,
            amount: line.amount,
            noCharge,
            warrantyMonths: Number(it.warrantyMonthNo) || 0,
          };
        })
        // Lọc dòng rác (không có gì để hiển thị).
        .filter((l) => l.quantity > 0 || l.unitPrice > 0 || l.amount > 0);
    },
    // Subtotal = sum line amounts (sau chiết khấu per-line + đã zero dòng BH DDV).
    subtotal() {
      return this.lineItems.reduce((s, l) => s + (Number(l.amount) || 0), 0);
    },
    // Chiết khấu trên hoá đơn (bill-level).
    billDiscountAmount() {
      return getServiceBillDiscount(this.bill);
    },
    // Mã coupon đã áp dụng cho hoá đơn (Bill.couponCode).
    couponCode() {
      return (this.bill && this.bill.couponCode) ? String(this.bill.couponCode).trim() : '';
    },
    // Danh sách mã voucher đã dùng (từ BillItem.voucherCode hoặc BillItem.vouchers[].code) — dedup.
    voucherCodes() {
      const items = (this.bill && this.bill.billItems) || [];
      const codes = new Set();
      items.forEach((it) => {
        if (it.voucherCode) codes.add(String(it.voucherCode).trim());
        if (Array.isArray(it.vouchers)) {
          it.vouchers.forEach((v) => {
            const code = v && (v.code || v.voucherCode);
            if (code) codes.add(String(code).trim());
          });
        }
      });
      return Array.from(codes).filter(Boolean);
    },
    // Khách phải trả = subtotal (đã trừ chiết khấu per-line + zero dòng BH DDV) − chiết khấu bill-level.
    totalAmount() {
      return Math.max(0, this.subtotal - this.billDiscountAmount);
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '';
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    formatMoney(value) {
      const num = Number(value);
      if (!num) return '0';
      return num.toLocaleString('vi-VN');
    },
  },
};
</script>

<style scoped>
.repair-bill-print {
  width: 148mm;
  margin: 0 auto;
  font-family: 'Times New Roman', serif;
  font-size: 11pt;
  color: #000;
  background: #fff;
  padding: 8mm 6mm;
}
.rb-header {
  text-align: center;
}
.rb-logo {
  max-height: 28mm;
  object-fit: contain;
}
.rb-tagline {
  font-weight: 700;
  font-size: 11pt;
  line-height: 1.3;
}
.rb-store-line {
  font-size: 10pt;
  margin-top: 2px;
}
.rb-title {
  text-align: center;
  font-size: 20pt;
  font-weight: 700;
  margin: 12px 0 4px 0;
}
.rb-divider {
  border: none;
  border-top: 1px dashed #000;
  margin: 4px 0;
}
.rb-info-block {
  margin: 6px 0;
  line-height: 1.6;
}
.rb-items {
  width: 100%;
  border-collapse: collapse;
  margin: 6px 0;
}
.rb-items th,
.rb-items td {
  padding: 3px 5px;
  vertical-align: top;
  font-size: 10.5pt;
}
.rb-items thead th {
  border-bottom: 1px solid #000;
  font-weight: 700;
  text-align: left;
}
.rb-col-name {
  width: auto;
}
.rb-col-qty {
  width: 6%;
}
.rb-col-price,
.rb-col-discount,
.rb-col-amount {
  width: 17%;
  white-space: nowrap;
}
.rb-free-tag {
  font-style: italic;
  color: #666;
}
.rb-col-warranty {
  width: 10%;
}
/* Áp dụng nowrap cho cell tiền — tránh vỡ dòng "- 24.590.000" thành 2 hàng. */
.rb-items td.text-right,
.rb-items th.text-right {
  white-space: nowrap;
}
.rb-subtotal-row th {
  border-top: 1px solid #000;
  font-weight: 500;
}
.rb-discount-row th {
  font-weight: 500;
}
.rb-total-row th {
  border-top: 1px solid #000;
  font-weight: 700;
}
.rb-promo-info {
  margin: 4px 0 6px 0;
  font-size: 10.5pt;
  line-height: 1.5;
}
.text-right {
  text-align: right;
}
.rb-meta {
  margin: 6px 0;
  line-height: 1.6;
}
.rb-policy {
  font-size: 10.5pt;
  line-height: 1.5;
}
.rb-strong {
  font-weight: 700;
  margin-top: 4px;
}
.rb-thanks {
  text-align: center;
  font-weight: 700;
  margin-top: 12px;
}
@media print {
  .repair-bill-print {
    padding: 0;
  }
  @page {
    size: A5 portrait;
    margin: 8mm;
  }
}
</style>
